import { BaseModel } from '../../../../../../core/_base/crud';

interface Contact {
  id: number;
  contact_id: number;
  first_name: string;
  last_name: string;
}

interface RelationType {
  id: number;
  category: {
    id: number;
    name: string;
    entity_type: 'CONTACT' | 'PATIENT' | 'DOCTOR' | 'FACILITY' | 'AFFILIATION_GROUP';
  };
  description_type: string;
}

interface AffiliationGroup {
  id: number;
  name: string;
}

export class AffiliationRelation extends BaseModel {
  constructor(
    public id = 0,
    public contact: Partial<Contact> = {},
    public affiliation_group: Partial<AffiliationGroup> = {},
    public relation_type: Partial<RelationType> = {},
    public title = '',
    public is_prime = false,
    public phi_authorized = false,
    public emergency_contact = false,
    public financial_responsible = false,
  ) {
    super();
  }
}
